var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep7Walkthrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 155,
    viewBox: "0 0 145 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_9556)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.615 69.0532C49.9517 75.2138 54.7805 91.1765 62.5283 97.5013C70.2761 103.826 21.3339 94.6812 21.3339 94.6812C21.3339 94.6812 21.9886 72.6674 20.1881 56.1571C18.3875 39.6467 10.8034 24.259 32.601 18.4543C54.535 12.814 70.1397 10.8152 69.8396 24.834C69.5396 38.8527 66.866 41.0705 59.7729 52.05C52.8163 62.8926 47.2782 62.8926 48.615 69.0532Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9247 55.4453C20.9247 55.4453 29.7365 83.1268 54.1803 85.7827C54.1803 85.7827 56.7447 93.0659 64.0561 97.9943C71.5311 102.786 76.769 104.922 76.769 104.922C76.769 104.922 24.7168 94.6813 22.1251 94.4349C19.3697 94.298 13.0132 102.348 13.0132 102.348L20.9247 55.4727V55.4453Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2717 41.755C26.2717 41.755 11.5945 40.7146 12.904 48.3263C14.2953 56.4035 19.8334 57.1154 22.0977 59.4975C28.8088 66.4794 36.2566 74.2281 48.4785 73.7078C60.7004 73.1876 66.2385 63.5224 64.247 43.0145C62.1463 22.3424 30.9095 11.7736 26.2171 41.755H26.2717Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.436477 139.941C2.37343 125.84 9.65748 107.906 14.5681 97.6384C19.6696 87.2612 53.7983 95.2015 68.3391 100.486C77.6965 103.772 96.2749 109.248 105.059 122.5C112.589 133.835 116.163 144.541 113.626 146.567C111.089 148.593 95.8657 136.382 72.5131 139.941C49.1605 143.5 -0.327393 145.088 0.436477 139.941Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4732 113.382C40.9218 105.469 70.058 101.828 81.2705 91.2314C100.258 73.2699 116.872 54.1858 119.409 43.3706C119.409 43.3706 114.553 57.5262 115.972 70.1212C116.927 78.6091 122.083 93.2028 114.553 108.235C95.8659 145.581 83.6167 134.547 64.3563 143.528C45.0958 152.509 20.1336 121.213 30.4459 113.382H30.4732Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.95 31.3231C132.886 48.8191 126.857 85.3171 115.126 107.084C109.179 118.064 103.914 68.4234 104.241 67.7389C104.405 67.383 112.616 57.2249 115.999 45.9716C119.137 35.5671 121.319 20.0698 121.155 16.0723C120.801 7.77603 134.905 16.0175 133.977 31.3231H133.95Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.355 23.1091C120.064 6.87254 115.099 -4.13435 120.609 1.506C126.12 7.14634 127.457 14.539 132.177 20.6722C136.896 26.8054 134.796 32.5553 132.204 41.7551C129.639 50.9549 122.355 23.1091 122.355 23.1091Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.859 38.442C142.516 22.9995 143.553 26.0935 144.317 17.1675C145.081 8.24153 136.978 -0.082088 130.049 7.63916C123.12 15.3604 121.592 13.2521 122.219 23.9305C122.847 34.6088 119.9 45.8895 119.9 45.8895L132.859 38.442Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.505 147.02C90.6548 142.803 52.2976 155.426 23.7343 155.179C-4.99268 154.987 -3.16484 140.366 5.91975 119.338C5.91975 119.338 82.8524 130.646 96.1655 134.644C109.315 138.696 122.355 151.209 106.478 147.02H106.505Z",
    fill: "#E64460"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_9556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.371,
    height: 155,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7Walkthrough);
export default __webpack_public_path__ + "static/media/step_7_walkthrough.d1a95df6b5e836c85ada5ed2f280163b.svg";
export { ForwardRef as ReactComponent };